// Hydrant types whose "volume" field (Datenportal: "Wassermenge / Volumen / Nenndurchmesser")
// holds the nominal diameter, shown as the usual short designation (e.g. "UH 100").
const HYDRANT_PREFIX: Partial<Record<string, string>> = {
  UNTERFLURHYDRANT: "UH",
  UEBERFLURHYDRANT: "ÜH",
  WUERTTEMBERGER_SCHACHTHYDRANT: "DN",
};

// "100", "DN100", "DN 100", "100mm", "100 mm"
const NOMINAL_DIAMETER = /^(?:DN\s*)?(\d{2,4})\s*(?:mm)?$/i;

/**
 * Formats the free-text "volume" field of a water supply point for the map.
 * The field has no fixed unit, so a unit is never invented: hydrants with a plain
 * nominal diameter become "UH 100" / "ÜH 100" / "DN 100", everything else is shown as entered.
 */
export function formatWaterSupplyVolume(
  type: string | undefined,
  volume: string | null | undefined,
): string | undefined {
  const value = volume?.trim();
  if (!value) return undefined;

  const prefix = type ? HYDRANT_PREFIX[type] : undefined;
  const diameter = prefix ? NOMINAL_DIAMETER.exec(value)?.[1] : undefined;
  return diameter ? `${prefix} ${diameter}` : value;
}
